document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('.mobile-toggle');
  var nav=document.getElementById('SiteNav');
  if(toggle&&nav){toggle.addEventListener('click',function(){var open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');});nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){nav.classList.remove('open');toggle.setAttribute('aria-expanded','false');});});}
});
/* Homepage promo: appears after specified delay and stays dismissed for the session. */
(function(){
  function setup(){
    var modal=document.getElementById('oss-bf-modal');
    if(!modal||modal.dataset.popupReady==='yes')return;
    modal.dataset.popupReady='yes';
    var dialog=modal.querySelector('.oss-bf-dialog');
    var close=modal.querySelector('.oss-bf-close');
    var key=modal.dataset.popupKey||'oss-bf-promo';
    try{if(sessionStorage.getItem(key)==='dismissed'&&!window.Shopify?.designMode)return}catch(error){}
    var previousFocus=null;
    function show(){
      if(!modal.isConnected||modal.dataset.popupReady!=='yes')return;
      previousFocus=document.activeElement;
      modal.hidden=false;
      document.body.classList.add('oss-bf-open');
      close.focus();
    }
    function hide(){
      modal.hidden=true;
      document.body.classList.remove('oss-bf-open');
      try{sessionStorage.setItem(key,'dismissed')}catch(error){}
      if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
    }
    modal.querySelectorAll('[data-bf-close]').forEach(function(button){button.addEventListener('click',hide)});
    modal.addEventListener('keydown',function(event){
      if(event.key==='Escape'){hide();return}
      if(event.key!=='Tab')return;
      var focusable=Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled])'));
      var first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    });
    window.setTimeout(show,Number(modal.dataset.delay)||5000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
